export const muscleGroupSection = {
  color: '#f9f9f9',
};

export const titleBarStyle = { margin: 0, justifyContent: 'flex-end' };
